import { render, staticRenderFns } from "./TwoToutSiyu.vue?vue&type=template&id=3c4ec8cc&"
import script from "./TwoToutSiyu.vue?vue&type=script&lang=js&"
export * from "./TwoToutSiyu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports